// // import React, { useEffect, useState } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import DoneIcon from "@mui/icons-material/Done";
// // import MailOutlineIcon from "@mui/icons-material/MailOutline";
// // import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
// // import AppleIcon from "@mui/icons-material/Apple";
// // import FacebookIcon from "@mui/icons-material/Facebook";
// // import "./SignUpGetStarted.css";
// // import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
// // import { useDispatch } from "react-redux";
// // import { GoogleLogin } from "@react-oauth/google";
// // import { getFeatureFlags, googleLoginSignup } from "../../api/auth";
// import { jwtDecode } from "jwt-decode";
// // import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
// // import { setAuthTokens } from "../../api/index";
// // import { useGoogleLogin } from "@react-oauth/google";

// // const SignUpGetStarted = () => {
// //   const navigate = useNavigate();
// //   const [isMobile, setIsMobile] = useState(false);
// //   const dispatch = useDispatch();
// //   const [referralCode, setReferralCode] = useState("");
// //   const [flags, setFlags] = useState({
// //     isGoogleEnable: false,
// //     isMetaEnable: false,
// //     isAppleEnable: false,
// //   });
// //   const [loading, setLoading] = useState(true);
// //   const location = useLocation();

// //   useEffect(() => {
// //     const fetchFeatureFlags = async () => {
// //       try {
// //         const data = await getFeatureFlags();
// //         if (data.success && data.data) {
// //           setFlags({
// //             isGoogleEnable: data.data.isGoogleEnable,
// //             isMetaEnable: data.data.isMetaEnable,
// //             isAppleEnable: data.data.isAppleEnable,
// //           });
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch flags:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchFeatureFlags();
// //   }, []);

// //   useEffect(() => {
// //     const checkIsMobile = () => {
// //       setIsMobile(window.innerWidth <= 768);
// //     };

// //     checkIsMobile();
// //     window.addEventListener("resize", checkIsMobile);

// //     return () => {
// //       window.removeEventListener("resize", checkIsMobile);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const params = new URLSearchParams(location.search);
// //     const code = params.get("referralcode");
// //     if (code) {
// //       setReferralCode(code);
// //       console.log("Referral code:", code);
// //     }
// //   }, [location.search]);

// //   // Google login logic here
// //   const handleGoogleSuccess = async (credentialResponse) => {
// //     try {
// //       const idToken = credentialResponse.credential;
// //       const decoded = jwtDecode(idToken);
// //       console.log("Google user info:", decoded);

// //       const response = await googleLoginSignup(idToken, referralCode || "");
// //       console.log("Backend Response:", response);
// //       if (response?.data?.user.userId) {
// //         localStorage.setItem("userId", response.data.user.userId);
// //       }

// //       setAuthTokens(response.data);
// //       dispatch(setUserDetails(response.data.userDetails));
// //       dispatch(setActiveComponent("signUpSuccessfull"));
// //       navigate("/signup");
// //     } catch (error) {
// //       console.error("Google signup failed:", error);
// //     }
// //   };

// //   const handleGoogleError = () => {
// //     alert("Google signup failed!");
// //   };

// //   const login = useGoogleLogin({
// //     onSuccess: async (tokenResponse) => {
// //       try {
// //         const credentialResponse = { credential: tokenResponse.access_token };
// //         await handleGoogleSuccess(credentialResponse);
// //       } catch (err) {
// //         console.error("Google login failed:", err);
// //         handleGoogleError();
// //       }
// //     },
// //     onError: handleGoogleError,
// //   });

// //   // Email Signup logic
// //   const handleEmailSignUp = () => {
// //     console.log("Email sign up clicked");
// //     dispatch(setActiveComponent("enterEmail"));
// //     navigate("/signup");
// //   };

// //   // Phone Signup logic here
// //   const handlePhoneSignUp = () => {
// //     console.log("Phone sign up clicked");
// //     navigate("/signup");
// //     dispatch(setActiveComponent("enterMobileNumber"));
// //   };

// //   const handleAppleSignUp = () => {
// //     console.log("Apple sign up clicked");
// //     // Add Apple sign-up logic here
// //   };

// //   const handleFacebookSignUp = () => {
// //     console.log("Facebook sign up clicked");
// //   };

// //   const handleLoginClick = () => {
// //     console.log("Login clicked - navigating to GetStartedPage");
// //     navigate("/login");
// //   };

// //   const handleDownloadGoogleAppClick = () => {
// //     window.open(
// //       "https://play.google.com/store/apps/details?id=com.amalgamate",
// //       "_blank"
// //     );
// //   };

// //   const handleDownloadAppleAppClick = () => {
// //     window.open(
// //       "https://apps.apple.com/in/app/amalgamate/id6744918457",
// //       "_blank"
// //     );
// //   };

// //   return (
// //     <div className="LandingPage">
// //       <div className="landingPageContainer">
// //         {/* Left Section - Features (Desktop only) */}
// //         {!isMobile && (
// //           <div className="landingLeftSection">
// //             <div className="landingLeftSectionContainer">
// //               <div className="amalgamateLogoContainer">
// //                 <img
// //                   className="webAmalgamateLogo"
// //                   src="/Assets/landingPage/AmalgamateLogo.svg"
// //                   alt="no img found"
// //                 />
// //               </div>
// //               <div className="leftSectionContentContainer">
// //                 <div className="leftSectionContent">
// //                   <DoneIcon
// //                     sx={{
// //                       height: "20px",
// //                       width: "20px",
// //                       color: "#48D1CC",
// //                       marginTop: "5px",
// //                     }}
// //                   />
// //                   <div className="textContainer">
// //                     <span className="contentHeading">Proof of Humanity</span>
// //                     <span className="contentTexts">
// //                       Only real humans can participate.
// //                     </span>
// //                     <span className="contentTexts">No bots, no duplicates</span>
// //                   </div>
// //                 </div>
// //                 <div className="leftSectionContent">
// //                   <DoneIcon
// //                     sx={{
// //                       height: "20px",
// //                       width: "20px",
// //                       color: "#48D1CC",
// //                       marginTop: "5px",
// //                     }}
// //                   />
// //                   <div className="textContainer">
// //                     <span className="contentHeading">Full Privacy Control</span>
// //                     <span className="contentTexts">Verified Human</span>
// //                     <span className="contentTexts">Verified Age</span>
// //                     <span className="contentTexts">
// //                       Verified Voting regions
// //                     </span>
// //                   </div>
// //                 </div>
// //                 <div className="leftSectionContent">
// //                   <DoneIcon
// //                     sx={{
// //                       height: "20px",
// //                       width: "20px",
// //                       color: "#48D1CC",
// //                       marginTop: "5px",
// //                     }}
// //                   />
// //                   <div className="textContainer">
// //                     <span className="contentHeading">
// //                       End the debates, focus on solutions
// //                     </span>
// //                     <span className="contentTexts">
// //                       Advanced content quality voting system to provide users a
// //                       more nuanced and transparent way of to evaluate content
// //                     </span>
// //                   </div>
// //                 </div>
// //               </div>
// //               <div className="lowerSection">
// //                 <div className="webGetTheAppContainer">
// //                   <div className="fadingLine1"></div>
// //                   <span className="webGetTheAppText">Get The App</span>
// //                   <div className="fadingLine2"></div>
// //                 </div>
// //                 <div className="downloadAppCards">
// //                   <div className="downloadAppCardContainer">
// //                     <div
// //                       className="webDownloadAppCard"
// //                       onClick={handleDownloadGoogleAppClick}
// //                     >
// //                       <img
// //                         src="/Assets/LandingPage/playstoreIcon.svg"
// //                         alt="no img found"
// //                         className="webDownloadAppCardIcon"
// //                       />
// //                       <div className="downloadAppCardTextContainer">
// //                         <span className="webDownloadAppCardText1">
// //                           Get it on
// //                         </span>
// //                         <span className="webDownloadAppCardText2">
// //                           Google Play
// //                         </span>
// //                       </div>
// //                     </div>
// //                     <div
// //                       className="webDownloadAppCard"
// //                       onClick={handleDownloadAppleAppClick}
// //                     >
// //                       <img
// //                         src="/Assets/LandingPage/appStoreIcon.svg"
// //                         alt="no img found"
// //                         className="webDownloadAppCardIcon2"
// //                       />
// //                       <div className="downloadAppCardTextContainer">
// //                         <span className="webDownloadAppCardText1">
// //                           Get it on
// //                         </span>
// //                         <span className="webDownloadAppCardText2">
// //                           App Store
// //                         </span>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {/* Right Section - Sign Up Form */}
// //         <div className="landingRightSection">
// //           {/* Mobile Logo at top */}
// //           {isMobile && (
// //             <div className="mobileLogoContainer">
// //               <img
// //                 className="mobileAmalgamateLogo"
// //                 src="/Assets/landingPage/AmalgamateLogo.svg"
// //                 alt="no img found"
// //               />
// //             </div>
// //           )}

// //           <div className="landingRightSectionContainer">
// //             <div className="GetStarted">
// //               <span className="getStartedText">Let's Get Started!</span>
// //               <p className="getStartedSubtitle">
// //                 Choose your preferred sign-up method
// //               </p>

// //               {!loading && (
// //                 <div className="signupButtonsContainer">
// //                   {flags.isGoogleEnable && (
// //                     <button
// //                       className="signupButton googleButton"
// //                       onClick={() => login()}
// //                     >
// //                       <img
// //                         src="/Assets/GetStarted/googleIcon.svg"
// //                         alt="Google"
// //                         className="signupButtonIcon"
// //                       />
// //                       <span className="signupButtonText">
// //                         Sign up with Google
// //                       </span>
// //                     </button>
// //                   )}

// //                   {flags.isAppleEnable && (
// //                     <button
// //                       className="signupButton appleButton"
// //                       onClick={handleAppleSignUp}
// //                     >
// //                       <AppleIcon className="signupButtonIcon" />
// //                       <span className="signupButtonText">
// //                         Sign up with Apple
// //                       </span>
// //                     </button>
// //                   )}

// //                   {flags.isMetaEnable && (
// //                     <button
// //                       className="signupButton facebookButton"
// //                       onClick={handleFacebookSignUp}
// //                     >
// //                       <FacebookIcon className="signupButtonIcon" />
// //                       <span className="signupButtonText">
// //                         Sign up with Facebook
// //                       </span>
// //                     </button>
// //                   )}

// //                   {/* Always visible buttons */}
// //                   <button
// //                     className="signupButton phoneButton"
// //                     onClick={handlePhoneSignUp}
// //                   >
// //                     <PhoneIphoneIcon className="signupButtonIcon" />
// //                     <span className="signupButtonText">
// //                       Sign up with Phone Number
// //                     </span>
// //                   </button>

// //                   <button
// //                     className="signupButton emailButton"
// //                     onClick={handleEmailSignUp}
// //                   >
// //                     <MailOutlineIcon className="signupButtonIcon" />
// //                     <span className="signupButtonText">Sign up with Email</span>
// //                   </button>
// //                 </div>
// //               )}

// //               {/* Footer Text */}
// //               <div className="signUpContainer">
// //                 <span className="signUpText1">Already have an account? </span>
// //                 <span className="signUpText2" onClick={handleLoginClick}>
// //                   Log in
// //                 </span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Mobile Download Cards at bottom */}
// //           {isMobile && (
// //             <div className="mobileDownloadSection">
// //               <div className="mobileGetTheAppContainer">
// //                 <div className="mobileFadingLine1"></div>
// //                 <span className="mobileGetTheAppText">Get The App</span>
// //                 <div className="mobileFadingLine2"></div>
// //               </div>
// //               <div className="mobileDownloadAppCards">
// //                 <div className="mobileDownloadAppCardContainer">
// //                   <div
// //                     className="mobileDownloadAppCard"
// //                     onClick={handleDownloadGoogleAppClick}
// //                   >
// //                     <img
// //                       src="/Assets/LandingPage/playstoreIcon.svg"
// //                       alt="no img found"
// //                       className="mobileDownloadAppCardIcon"
// //                     />
// //                     <div className="mobileDownloadAppCardTextContainer">
// //                       <span className="mobileDownloadAppCardText1">
// //                         Get it on
// //                       </span>
// //                       <span className="mobileDownloadAppCardText2">
// //                         Google Play
// //                       </span>
// //                     </div>
// //                   </div>
// //                   <div
// //                     className="mobileDownloadAppCard"
// //                     onClick={handleDownloadAppleAppClick}
// //                   >
// //                     <img
// //                       src="/Assets/LandingPage/appStoreIcon.svg"
// //                       alt="no img found"
// //                       className="mobileDownloadAppCardIcon2"
// //                     />
// //                     <div className="mobileDownloadAppCardTextContainer">
// //                       <span className="mobileDownloadAppCardText1">
// //                         Get it on
// //                       </span>
// //                       <span className="mobileDownloadAppCardText2">
// //                         App Store
// //                       </span>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SignUpGetStarted;

// /*----------------------------------Final latest Code----------------------------------- */

// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import DoneIcon from "@mui/icons-material/Done";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
// import AppleIcon from "@mui/icons-material/Apple";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import "./SignUpGetStarted.css";
// import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
// import { useDispatch } from "react-redux";
// import { GoogleLogin } from "@react-oauth/google";
// import { getFeatureFlags, googleLoginSignup } from "../../api/auth";
// import { jwtDecode } from "jwt-decode";
// import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
// import { setAuthTokens } from "../../api/index";

// const SignUpGetStarted = () => {
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(false);
//   const dispatch = useDispatch();
//   const [referralCode, setReferralCode] = useState("");
//   const [flags, setFlags] = useState({
//     isGoogleEnable: false,
//     isMetaEnable: false,
//     isAppleEnable: false,
//   });
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();
//   const googleLoginRef = useRef(null);

//   useEffect(() => {
//     const fetchFeatureFlags = async () => {
//       try {
//         const data = await getFeatureFlags();
//         if (data.success && data.data) {
//           setFlags({
//             isGoogleEnable: data.data.isGoogleEnable,
//             isMetaEnable: data.data.isMetaEnable,
//             isAppleEnable: data.data.isAppleEnable,
//           });
//         }
//       } catch (error) {
//         console.error("Failed to fetch flags:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchFeatureFlags();
//   }, []);

//   useEffect(() => {
//     const checkIsMobile = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     checkIsMobile();
//     window.addEventListener("resize", checkIsMobile);

//     return () => {
//       window.removeEventListener("resize", checkIsMobile);
//     };
//   }, []);

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const code = params.get("referralcode");
//     if (code) {
//       setReferralCode(code);
//       console.log("Referral code:", code);
//     }
//   }, [location.search]);

//   // ✅ Google Login Success Handler
//   const handleGoogleSuccess = async (credentialResponse) => {

//     try {
//       const idToken = credentialResponse.credential;
//       const decoded = jwtDecode(idToken);
//       console.log("Google user info:", decoded);

//       const response = await googleLoginSignup(idToken, referralCode || "");
//       console.log("Backend Response:", response);

//       if (response?.data?.userDetails?.userId) {
//         localStorage.setItem("userId", response.data.userDetails.userId);
//         console.log("User ID:", response.data.userDetails.userId);
//       }

//       setAuthTokens(response.data);
//       dispatch(setUserDetails(response.data.userDetails));
//       dispatch(setActiveComponent("signUpSuccessfull"));
//      navigate("/signUp");
//     } catch (error) {
//       console.error("Google signup failed:", error);
//       alert("Google signup failed!");
//     }
//   };

//   const handleGoogleError = (error) => {
//     alert("Google signup failed!");

//     console.log("Google signup failed:", error);
//   };

//   // 📱 Email Signup
//   const handleEmailSignUp = () => {
//     dispatch(setActiveComponent("enterEmail"));
//     navigate("/signup");
//   };

//   // 📱 Phone Signup
//   const handlePhoneSignUp = () => {
//     navigate("/signup");
//     dispatch(setActiveComponent("enterMobileNumber"));
//   };

//   const handleAppleSignUp = () => {
//     console.log("Apple sign up clicked");
//   };

//   const handleFacebookSignUp = () => {
//     console.log("Facebook sign up clicked");
//   };

//   const handleLoginClick = () => {
//     navigate("/login");
//   };

//   const handleDownloadGoogleAppClick = () => {
//     window.open(
//       "https://play.google.com/store/apps/details?id=com.amalgamate",
//       "_blank"
//     );
//   };

//   const handleDownloadAppleAppClick = () => {
//     window.open(
//       "https://apps.apple.com/in/app/amalgamate/id6744918457",
//       "_blank"
//     );
//   };

//   return (
//     <div className="LandingPage">
//       <div className="landingPageContainer">
//         {/* Left Section */}
//         {!isMobile && (
//           <div className="landingLeftSection">
//             <div className="landingLeftSectionContainer">
//               <div className="amalgamateLogoContainer">
//                 <img
//                   className="webAmalgamateLogo"
//                   src="/Assets/landingPage/AmalgamateLogo.svg"
//                   alt="no img found"
//                 />
//               </div>

//               {/* Features Section */}
//               <div className="leftSectionContentContainer">
//                 <div className="leftSectionContent">
//                   <DoneIcon sx={{ height: "20px", width: "20px", color: "#48D1CC", marginTop: "5px" }} />
//                   <div className="textContainer">
//                     <span className="contentHeading">Proof of Humanity</span>
//                     <span className="contentTexts">Only real humans can participate.</span>
//                     <span className="contentTexts">No bots, no duplicates</span>
//                   </div>
//                 </div>

//                 <div className="leftSectionContent">
//                   <DoneIcon sx={{ height: "20px", width: "20px", color: "#48D1CC", marginTop: "5px" }} />
//                   <div className="textContainer">
//                     <span className="contentHeading">Full Privacy Control</span>
//                     <span className="contentTexts">Verified Human</span>
//                     <span className="contentTexts">Verified Age</span>
//                     <span className="contentTexts">Verified Voting regions</span>
//                   </div>
//                 </div>

//                 <div className="leftSectionContent">
//                   <DoneIcon sx={{ height: "20px", width: "20px", color: "#48D1CC", marginTop: "5px" }} />
//                   <div className="textContainer">
//                     <span className="contentHeading">
//                       End the debates, focus on solutions
//                     </span>
//                     <span className="contentTexts">
//                       Advanced content quality voting system to provide users a
//                       more nuanced and transparent way to evaluate content
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* App Download Section */}
//               <div className="lowerSection">
//                 <div className="webGetTheAppContainer">
//                   <div className="fadingLine1"></div>
//                   <span className="webGetTheAppText">Get The App</span>
//                   <div className="fadingLine2"></div>
//                 </div>
//                 <div className="downloadAppCards">
//                   <div className="downloadAppCardContainer">
//                     <div
//                       className="webDownloadAppCard"
//                       onClick={handleDownloadGoogleAppClick}
//                     >
//                       <img
//                         src="/Assets/LandingPage/playstoreIcon.svg"
//                         alt="no img found"
//                         className="webDownloadAppCardIcon"
//                       />
//                       <div className="downloadAppCardTextContainer">
//                         <span className="webDownloadAppCardText1">Get it on</span>
//                         <span className="webDownloadAppCardText2">Google Play</span>
//                       </div>
//                     </div>

//                     <div
//                       className="webDownloadAppCard"
//                       onClick={handleDownloadAppleAppClick}
//                     >
//                       <img
//                         src="/Assets/LandingPage/appStoreIcon.svg"
//                         alt="no img found"
//                         className="webDownloadAppCardIcon2"
//                       />
//                       <div className="downloadAppCardTextContainer">
//                         <span className="webDownloadAppCardText1">Get it on</span>
//                         <span className="webDownloadAppCardText2">App Store</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Right Section */}
//         <div className="landingRightSection">
//           {isMobile && (
//             <div className="mobileLogoContainer">
//               <img
//                 className="mobileAmalgamateLogo"
//                 src="/Assets/landingPage/AmalgamateLogo.svg"
//                 alt="no img found"
//               />
//             </div>
//           )}

//           <div className="landingRightSectionContainer">
//             <div className="GetStarted">
//               <span className="getStartedText">Let's Get Started!</span>
//               <p className="getStartedSubtitle">
//                 Choose your preferred sign-up method
//               </p>

//               {!loading && (
//               <div className="signupButtonsContainer">
//                   {flags.isGoogleEnable && (
//                     <div style={{ display: "flex", justifyContent: "center" }}>
//                       <GoogleLogin
//                         onSuccess={handleGoogleSuccess}
//                         onError={(error) => handleGoogleError(error)}
//                         useOneTap={false}
//                       />
//                     </div>
//                   )}

//                   {flags.isAppleEnable && (
//                     <button
//                       className="signupButton appleButton"
//                       onClick={handleAppleSignUp}
//                     >
//                       <AppleIcon className="signupButtonIcon" />
//                       <span className="signupButtonText">
//                         Sign up with Apple
//                       </span>
//                     </button>
//                   )}

//                   {flags.isMetaEnable && (
//                     <button
//                       className="signupButton facebookButton"
//                       onClick={handleFacebookSignUp}
//                     >
//                       <FacebookIcon className="signupButtonIcon" />
//                       <span className="signupButtonText">
//                         Sign up with Facebook
//                       </span>
//                     </button>
//                   )}

//                   <button
//                     className="signupButton phoneButton"
//                     onClick={handlePhoneSignUp}
//                   >
//                     <PhoneIphoneIcon className="signupButtonIcon" />
//                     <span className="signupButtonText">
//                       Sign up with Phone Number
//                     </span>
//                   </button>

//                   <button
//                     className="signupButton emailButton"
//                     onClick={handleEmailSignUp}
//                   >
//                     <MailOutlineIcon className="signupButtonIcon" />
//                     <span className="signupButtonText">
//                       Sign up with Email
//                     </span>
//                   </button>
//                 </div>
//               )}

//               <div className="signUpContainer">
//                 <span className="signUpText1">Already have an account? </span>
//                 <span className="signUpText2" onClick={handleLoginClick}>
//                   Log in
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Mobile Download Section */}
//           {isMobile && (
//             <div className="mobileDownloadSection">
//               <div className="mobileGetTheAppContainer">
//                 <div className="mobileFadingLine1"></div>
//                 <span className="mobileGetTheAppText">Get The App</span>
//                 <div className="mobileFadingLine2"></div>
//               </div>
//               <div className="mobileDownloadAppCards">
//                 <div className="mobileDownloadAppCardContainer">
//                   <div
//                     className="mobileDownloadAppCard"
//                     onClick={handleDownloadGoogleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/playstoreIcon.svg"
//                       alt="no img found"
//                       className="mobileDownloadAppCardIcon"
//                     />
//                     <div className="mobileDownloadAppCardTextContainer">
//                       <span className="mobileDownloadAppCardText1">Get it on</span>
//                       <span className="mobileDownloadAppCardText2">Google Play</span>
//                     </div>
//                   </div>
//                   <div
//                     className="mobileDownloadAppCard"
//                     onClick={handleDownloadAppleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/appStoreIcon.svg"
//                       alt="no img found"
//                       className="mobileDownloadAppCardIcon2"
//                     />
//                     <div className="mobileDownloadAppCardTextContainer">
//                       <span className="mobileDownloadAppCardText1">Get it on</span>
//                       <span className="mobileDownloadAppCardText2">App Store</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUpGetStarted;

/** --------------------------Final correct code------------------------------ */

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLeftSection from "../Shared/AuthLeftSection/AuthLeftSection";
import "./SignUpGetStarted.css";
import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
import { useDispatch, useSelector } from "react-redux";
import { GoogleLogin } from "@react-oauth/google";
import { googleLoginSignup } from "../../api/auth";
import { verifyReferralCode } from "../../api/auth";
import { jwtDecode } from "jwt-decode";
import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
import { setAuthTokens } from "../../api/index";
import { Snackbar, Alert } from '@mui/material';

const SignUpGetStarted = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const dispatch = useDispatch();
  const [referralCode, setReferralCode] = useState("");
  const flags = useSelector((state) => state.featureFlags?.flags) || {
    isGoogleEnable: true,
    isMetaEnable: false,
    isAppleEnable: false,
    isFaceEnabled: false,
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });
  const location = useLocation();

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };



  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("referralcode");
    if (code) {
      setReferralCode(code);
      console.log("Referral code:", code);

      // Validate once at entry and persist for the flow
      let mounted = true;
      (async () => {
        try {
          const res = await verifyReferralCode(code);
          if (!mounted) return;
          if (res?.success || res?.statusCode === 200) {
            // Persist for other steps
            localStorage.setItem("refreeAffiliateCode", code);
            localStorage.setItem("referralCode", code);
            localStorage.setItem("isReferralLocked", "true");
          } else {
            localStorage.removeItem("isReferralLocked");
            // keep code for manual override visibility if needed
          }
        } catch (e) {
          localStorage.removeItem("isReferralLocked");
        }
      })();
      return () => {
        mounted = false;
      };
    }
  }, [location.search]);

  // ✅ Google Login Success Handler
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse.credential;
      const decoded = jwtDecode(idToken);
      console.log("Google user info:", decoded);
      console.log("Google signup clicked - QA environment");
      console.log("Flags:", flags);
      console.log("Referral code:", referralCode);

      const response = await googleLoginSignup(idToken, referralCode || "");
      console.log("Backend Response:", response);


      if (response?.data?.userDetails?.userId) {
        localStorage.setItem("userId", response.data.userDetails.userId);
        console.log("User ID:", response.data.userDetails.userId);
      }

      setAuthTokens(response.data);
      dispatch(setUserDetails(response.data.userDetails));
      dispatch(setActiveComponent("signUpSuccessfull"));
      navigate("/signup" + window.location.search);
    } catch (error) {
      console.error("Google signup failed:", error);
      showSnackbar("Google signup failed!", 'error');
    }
  };

  const handleGoogleError = (error) => {
    console.log("Google signup clicked - QA environment");
    console.log("Flags:", flags);
    console.log("Referral code:", referralCode);
    showSnackbar("Google signup failed!", 'error');
    console.log("Google signup failed:", error);
  };

  const handleEmailSignUp = () => {
    dispatch(setActiveComponent("enterEmail"));
    navigate("/signup" + window.location.search);
  };

  const handlePhoneSignUp = () => {
    navigate("/signup" + window.location.search);
    dispatch(setActiveComponent("enterMobileNumber"));
  };


  const handleFacebookSignUp = () => {
    console.log("Facebook sign up clicked");
  };

  const handleLoginClick = () => {
    navigate("/login" + window.location.search);
  };

  const handleDownloadGoogleAppClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.amalgamate",
      "_blank"
    );
  };

  const handleDownloadAppleAppClick = () => {
    window.open(
      "https://apps.apple.com/in/app/amalgamate/id6744918457",
      "_blank"
    );
  };

  return (
    <div className="LandingPage">
      <div className="landingPageContainer">
        {/* Left Section */}
        {!isMobile && <AuthLeftSection />}

        {/* Right Section */}
        <div className="landingRightSection">
          {isMobile && (
            <div
              className="mobileLogoContainer"
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer' }}
              title="Return to Amalgamate Home"
            >
              <img
                className="mobileAmalgamateLogo"
                src="/Assets/LandingPage/AmalgamateLogo.svg"
                alt="Amalgamate Logo"
              />
            </div>
          )}

          <div className="landingRightSectionContainer">
            <div className="GetStarted">
              <span className="getStartedText">Let's Get Started</span>
              <button className="btnContainer" onClick={handleEmailSignUp}>
                <span className="btnText">Continue with Email</span>
              </button>

              <div className="dividerContainer">
                <div className="divider"></div>
                <span className="orText">OR</span>
                <div className="divider"></div>
              </div>

              {/* Conditional third-party buttons (aligned like GetStartedPage) */}
              {flags.isGoogleEnable && (
                <div
                  className="btnContainer btnContainerDuplicate"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                  }}
                >
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={handleGoogleError}
                    useOneTap={false}
                  />
                </div>
              )}

              {flags.isMetaEnable && (
                <button
                  className="btnContainer btnContainerDuplicate"
                  onClick={handleFacebookSignUp}
                >
                  <span className="btnText">Continue with Facebook</span>
                </button>
              )}

              <button
                className="btnContainer btnContainerDuplicate"
                onClick={handlePhoneSignUp}
              >
                <span className="btnText">Continue with Phone Number</span>
              </button>

              <div className="signUpContainer">
                <span className="signUpText1">Already have an account? </span>
                <span className="signUpText2" onClick={handleLoginClick}>
                  Log in
                </span>
              </div>
            </div>
          </div>

          {/* Mobile Download Section */}
          {isMobile && (
            <div className="mobileDownloadSection">
              <div className="mobileGetTheAppContainer">
                <div className="mobileFadingLine1"></div>
                <span className="mobileGetTheAppText">Get The App</span>
                <div className="mobileFadingLine2"></div>
              </div>
              <div className="mobileDownloadAppCards">
                <div className="mobileDownloadAppCardContainer">
                  <div
                    className="mobileDownloadAppCard"
                    onClick={handleDownloadGoogleAppClick}
                  >
                    <img
                      src="/Assets/LandingPage/playStoreIcon.svg"
                      alt="no img found"
                      className="mobileDownloadAppCardIcon"
                    />
                    <div className="mobileDownloadAppCardTextContainer">
                      <span className="mobileDownloadAppCardText1">
                        Get it on
                      </span>
                      <span className="mobileDownloadAppCardText2">
                        Google Play
                      </span>
                    </div>
                  </div>
                  <div
                    className="mobileDownloadAppCard"
                    onClick={handleDownloadAppleAppClick}
                  >
                    <img
                      src="/Assets/LandingPage/appStoreIcon.svg"
                      alt="no img found"
                      className="mobileDownloadAppCardIcon2"
                    />
                    <div className="mobileDownloadAppCardTextContainer">
                      <span className="mobileDownloadAppCardText1">
                        Get it on
                      </span>
                      <span className="mobileDownloadAppCardText2">
                        App Store
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SignUpGetStarted;
